import { Container } from "@material-ui/core";

export const PageContainer = Container;
